<template>
  <div>
    <div>
      <van-cell-group>
        <van-field
          readonly
          :value="data[0].companyName"
          label="企业名称"
          placeholder="无"
        />
      </van-cell-group>
      <!-- <van-cell-group>
        <van-field
          readonly
          :value="data[0].keyNo"
          label="企业KeyNo"
          placeholder="无"
        />
      </van-cell-group> -->
      <van-cell-group>
        <van-field
          readonly
          :value="data[0].roleDesc"
          label="当前查询主体在当前企业的角色描述"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data[0].count"
          label="当前企业股东变更次数"
          placeholder="无"
        />
      </van-cell-group>
    </div>
    <div
      class="item coll2 comWrapper card mt-2 mb-2 p-3"
      v-for="(item, index) in viewData"
      :key="index"
    >
      <div class="comWrapper-wrapper van-hairline--bottom">
        <span style="background: #f44336"></span>
        股东变更信息
      </div>
      <van-cell-group>
        <template v-for="(col, idx) in 列">
          <van-cell
            v-if="col.field != 'oldPartnerList' && col.field != 'newPartnerList'"
            :key="'col_' + idx"
            :title="col.title"
            :value="item[col.field]"
          />
          <van-cell
            v-if="(col.field == 'oldPartnerList' || col.field == 'newPartnerList')"
            :key="'col_' + idx"
          >
            <template #title>
              {{ col.title }}
            </template>
            <template #extra>
              <div class="van-cell__value">
                <div
                  v-for="(last, index) in item[col.field]"
                  :key="col.field + index"
                >
                  <span v-text="last.name" style="margin-right: 2px"></span>
                  <span class="mycs badge badge-warning">{{ last.stockPercent }}</span>
                </div>
              </div>
            </template>
          </van-cell>
        </template>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "parChangePromptCheck",
  components: {},
  props: ["data"],
  data() {
    return {
      列: [
        { title: "变更前股东信息", field: "oldPartnerList" },
        { title: "变更后股东信息", field: "newPartnerList" },
        { title: "变更日期", field: "changeDate" },
      ],
      页码: 1,
      每页数据量: 10,
      viewData: [],
    };
  },
  methods: {
    pagination() {
      this.viewData = this.data[0].partnerList;
    },
  },
  created() {
    if (this.data.length > 0) {
      this.data[0].roleDesc = this.data[0].roleDesc || "无";
      this.data[0].partnerList.forEach(
        (item, index) => (item.sort = index + 1)
      );
      this.pagination();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
</style>